import React, { useState } from "react";
import "./CareersFAQ.css";

const CareersFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);

const faqs = [
  {
    question: "How can I apply for a career at Sreenathji Enterprises?",
    answer:
      "You can apply directly through our Careers section by filling out the online application form. Alternatively, you may send your updated resume to careers@sreenathjienterprises.com with the role mentioned in the subject line.",
  },
  {
    question: "What kind of roles are available?",
    answer:
      "We offer opportunities in chemical sales and distribution, technical product support, industrial coatings, abrasives and cutting tools, as well as logistics and supply chain management.",
  },
  {
    question: "Do you provide training for new employees?",
    answer:
      "Yes, we provide role-specific training and mentorship to ensure our employees are equipped with the right technical and industry knowledge.",
  },
  {
    question: "Is prior industry experience required?",
    answer:
      "While prior experience in chemicals, coatings, or industrial distribution is preferred, we also welcome passionate freshers with strong learning potential.",
  },
  {
    question: "Does SE offer career growth opportunities?",
    answer:
      "Absolutely. We believe in promoting talent from within and provide continuous growth opportunities through training, challenging projects, and leadership roles.",
  },
];


  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="careers-faq">
      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
          >
            <button
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span>{faq.question}</span>
              <span className="faq-icon">
                {activeIndex === index ? "−" : "+"}
              </span>
            </button>
            <div
              className="faq-answer"
              style={{
                maxHeight: activeIndex === index ? "200px" : "0",
              }}
            >
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CareersFAQ;
